// extracted by mini-css-extract-plugin
export default {"newsItem":"index_newsItem_isvof","imgWp":"index_imgWp_mPTem","textPart":"index_textPart_r6nz6","title":"index_title_FjFVN","date":"index_date_bvcAG"};